import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Packages from "@/components/site/Packages";
import Playlist from "@/components/site/Playlist";
import PracticalInfo from "@/components/site/PracticalInfo";
import Guarantees from "@/components/site/Guarantees";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";
import PlaylistsPage from "@/components/site/PlaylistsPage";
import AdminPage from "@/components/site/AdminPage";
import GuideAdmin from "@/components/site/GuideAdmin";
import AuthCallback from "@/components/site/AuthCallback";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import MentionsLegales from "@/components/site/MentionsLegales";
import LaisserAvis from "@/components/site/LaisserAvis";
import SignaturePage from "@/components/site/SignaturePage";
import SoldePage from "@/components/site/SoldePage";
import LocalPage from "@/components/site/LocalPage";
import MaterielPage from "@/components/site/MaterielPage";
import TarifsPage from "@/components/site/TarifsPage";
import BlogPage from "@/components/site/BlogPage";
import BlogArticle from "@/components/site/BlogArticle";
import { LOCAL_PAGES } from "@/data/localPages";
import PaymentSuccess from "@/components/site/PaymentSuccess";
import PaymentCancel from "@/components/site/PaymentCancel";
import AssistantWidget from "@/components/site/AssistantWidget";
import { AuthProvider } from "@/auth/AuthContext";

function Landing() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        document.querySelector(location.hash)?.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  }, [location.hash]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Packages />
        <Gallery />
        <Playlist />
        <PracticalInfo />
        <Guarantees />
        <Testimonials />
        <QuoteForm />
      </main>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Le fragment session_id du retour OAuth doit être traité AVANT les routes normales
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/playlists" element={<PlaylistsPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/guide" element={<GuideAdmin />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
      <Route path="/laisser-un-avis" element={<LaisserAvis />} />
      <Route path="/signature/:token" element={<SignaturePage />} />
      <Route path="/solde/:token" element={<SoldePage />} />
      <Route path="/tarifs" element={<TarifsPage />} />
      <Route path="/materiel" element={<MaterielPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogArticle />} />
      {LOCAL_PAGES.map((p) => (
        <Route key={p.slug} path={p.path} element={<LocalPage page={p} />} />
      ))}
    </Routes>
  );
}

export default function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App min-h-screen overflow-x-clip bg-[#080C14] text-slate-100" data-testid="klmprod-app">
        <div className="grain" aria-hidden="true" />
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
        <AssistantWidget />
        <Toaster theme="dark" position="bottom-right" richColors closeButton />
      </div>
    </ReactLenis>
  );
}
